import { OnChanges, SimpleChange } from "@angular/core";
import * as lodash from 'lodash';

// ngOnChanges() can only be triggered by a component's parent.
// So if we want to trigger it from other places, we need to call it manually.
function change<T>(component: OnChanges, fieldName: string, newData: T) {
    const oldValue = lodash.get(component, fieldName);
    lodash.set(component, fieldName, newData);
    component.ngOnChanges({
        [fieldName]: new SimpleChange(oldValue, newData, false)
    });
}

function hasChanges(change: SimpleChange, isSame?: (prev: any, cur: any) => boolean) {
    if (change) {
        const { previousValue, currentValue } = change;
        return isSame ? !isSame(previousValue, currentValue) : previousValue !== currentValue;
    } else {
        return false;
    }
}

export const NgOnChangesUtility = {
    change,
    hasChanges
};
